import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=64d22c5a&scoped=true"
import script from "./Avatar.js?vue&type=script&lang=js&external"
export * from "./Avatar.js?vue&type=script&lang=js&external"
import style0 from "./Avatar.scss?vue&type=style&index=0&id=64d22c5a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d22c5a",
  null
  
)

export default component.exports